
import { Outlet } from "react-router-dom";

export default function RoutesRoot() {
  return (
    <>
      <Outlet />
    </>
  );
}